import { useCallback } from 'react';
import axios from 'axios';

import { useSysconfig } from '~/components/SystemConfiguration/SystemConfigurationScreen';

import type {
  AiClaimImportPreviewByClaimsResponse,
  AiClaimImportPreviewBySubOrgResponse,
  AiClaimImportStartResponse,
} from '../types';

export const useAiClaimImportActions = () => {
  // @ts-expect-error TODO: useSysconfig hook needs TypeScript definition
  const { organization } = useSysconfig();
  const urlPrefix = `/sysconfig/api/v1/organizations/${organization.id}/ai_claim_import`;

  const fetchPreviewBySubOrg = useCallback(async (): Promise<AiClaimImportPreviewBySubOrgResponse> => {
    const { data } = await axios.get<AiClaimImportPreviewBySubOrgResponse>(`${urlPrefix}/preview/by_sub_org`);
    return data;
  }, [urlPrefix]);

  const startImportBySubOrgs = useCallback(
    async (subOrgIds: number[]): Promise<AiClaimImportStartResponse> => {
      const { data } = await axios.post<AiClaimImportStartResponse>(`${urlPrefix}/start/by_sub_orgs`, {
        sub_organization_ids: subOrgIds,
      });
      return data;
    },
    [urlPrefix]
  );

  const fetchPreviewByClaims = useCallback(
    async (claimNumbers: string[]): Promise<AiClaimImportPreviewByClaimsResponse> => {
      const { data } = await axios.post<AiClaimImportPreviewByClaimsResponse>(`${urlPrefix}/preview/by_claims`, {
        claim_numbers: claimNumbers,
      });
      return data;
    },
    [urlPrefix]
  );

  const startImportByClaims = useCallback(
    async (claimNumbers: string[]): Promise<AiClaimImportStartResponse> => {
      const { data } = await axios.post<AiClaimImportStartResponse>(`${urlPrefix}/start/by_claims`, {
        claim_numbers: claimNumbers,
      });
      return data;
    },
    [urlPrefix]
  );

  return {
    fetchPreviewBySubOrg,
    fetchPreviewByClaims,
    startImportBySubOrgs,
    startImportByClaims,
  };
};
